import { render, staticRenderFns } from "./FailReasonData.vue?vue&type=template&id=ac735528&scoped=true&"
import script from "./FailReasonData.vue?vue&type=script&lang=ts&"
export * from "./FailReasonData.vue?vue&type=script&lang=ts&"
import style0 from "./FailReasonData.vue?vue&type=style&index=0&id=ac735528&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ac735528",
  null
  
)

export default component.exports